// extracted by mini-css-extract-plugin
export default {"inputContainer":"AddChildModal__inputContainer___V9VGe","buttonsContainer":"AddChildModal__buttonsContainer___msszL"};